package com.upcominds.expedite.data.news

import com.upcominds.expedite.data.NetworkClient
import com.upcominds.expedite.dto.CommunityNewsDTO
import com.upcominds.expedite.dto.NewsCommentCreateRequest
import com.upcominds.expedite.dto.NewsCommentDTO
import com.upcominds.expedite.dto.NewsReactionRequest
import com.upcominds.expedite.dto.NewsReactionType
import com.upcominds.expedite.dto.NewsSurveyAnswerRequest
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class NewsRepositoryImpl : NewsRepository {
    private val httpClient: HttpClient = NetworkClient.httpClient

    override suspend fun getMyNews(): List<CommunityNewsDTO> {
        return httpClient
            .get(NetworkClient.endpoint("api/communities/me/news"))
            .body<List<CommunityNewsDTO>>()
    }

    override suspend fun setReaction(newsId: String, reaction: NewsReactionType): CommunityNewsDTO {
        return httpClient
            .post(NetworkClient.endpoint("api/communities/me/news/$newsId/reaction")) {
                contentType(ContentType.Application.Json)
                setBody(NewsReactionRequest(reaction = reaction))
            }
            .body<CommunityNewsDTO>()
    }

    override suspend fun clearReaction(newsId: String): CommunityNewsDTO {
        return httpClient
            .delete(NetworkClient.endpoint("api/communities/me/news/$newsId/reaction"))
            .body<CommunityNewsDTO>()
    }

    override suspend fun addComment(newsId: String, request: NewsCommentCreateRequest): NewsCommentDTO {
        return httpClient
            .post(NetworkClient.endpoint("api/communities/me/news/$newsId/comments")) {
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            .body<NewsCommentDTO>()
    }

    override suspend fun answerSurvey(newsId: String, optionId: String): CommunityNewsDTO {
        return httpClient
            .post(NetworkClient.endpoint("api/communities/me/news/$newsId/survey/answer")) {
                contentType(ContentType.Application.Json)
                setBody(NewsSurveyAnswerRequest(optionId = optionId))
            }
            .body<CommunityNewsDTO>()
    }
}
